/**
 * Admin 사이트 > 굿즈 CRUD. 라우트 admin.php site.shop 와 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

const CTRL_TAG = "AdminShopProductController";

export const AdminShopProductController = {
    index(): void {
        noop(CTRL_TAG, "index");
    },
    create(): void {
        noop(CTRL_TAG, "create");
    },
    store(): void {
        noop(CTRL_TAG, "store");
    },
    edit(): void {
        noop(CTRL_TAG, "edit");
    },
    update(): void {
        noop(CTRL_TAG, "update");
    },
    destroy(): void {
        noop(CTRL_TAG, "destroy");
    },
};
